import { useMutation } from '@tanstack/react-query';
import post2faCodeApiCall from '../../api/calls/post2faCodeApiCall';

const useSend2faCodeMutation = () => useMutation(post2faCodeApiCall);

export default useSend2faCodeMutation;
